import { createFileRoute, redirect } from "@tanstack/react-router";
import { RouteError, RouteNotFound } from "@/components/route-error";
import { zodValidator, fallback } from "@tanstack/zod-adapter";
import { z } from "zod";

const searchSchema = z.object({
  title: fallback(z.string(), "").default(""),
  text: fallback(z.string(), "").default(""),
  url: fallback(z.string(), "").default(""),
});

export const Route = createFileRoute("/_authenticated/share")({
  errorComponent: RouteError,
  notFoundComponent: RouteNotFound,
  validateSearch: zodValidator(searchSchema),
  loaderDeps: ({ search }) => ({ ...search }),
  loader: ({ deps }) => {
    if (typeof window !== "undefined") {
      const parts = [deps.title, deps.text, deps.url].filter(Boolean);
      const text = parts.join("\n\n").slice(0, 10000);
      try {
        sessionStorage.setItem(
          "aria.capture.draft",
          JSON.stringify({ text, url: deps.url || null, ts: Date.now() }),
        );
      } catch {
        // sessionStorage may be unavailable in some embeds
      }
    }
    throw redirect({ to: "/capture" });
  },
  component: () => null,
});